import { LoginRoutes } from "config/LoginConfig";

export function redirectToConsentPage() {
  if (window.location.pathname !== LoginRoutes.CONSENT) {
    window.location.pathname = LoginRoutes.CONSENT;
  }
}
